import type { BlogSeo } from "./seo";

const managedSelector = 'title, meta[name="description"], meta[name="robots"], meta[name="author"], meta[property^="og:"], meta[property^="article:"], meta[name^="twitter:"], link[rel="canonical"], link[hreflang], #blog-structured-data';

/** Restore the normal app head before taking ownership of prerendered metadata. */
function restorePrerenderedHead() {
  const defaults = document.getElementById("blog-default-head");
  if (!(defaults instanceof HTMLScriptElement) || defaults.type !== "application/json") return;
  const html: unknown = JSON.parse(defaults.textContent || '""');
  if (typeof html !== "string") return;
  const fragment = document.createElement("template");
  fragment.innerHTML = html;
  document.head.querySelectorAll("[data-blog-seo]").forEach(node => node.remove());
  document.head.append(fragment.content);
  defaults.remove();
}

export function installBlogSeo(seo: BlogSeo): () => void {
  restorePrerenderedHead();
  const originals = Array.from(document.head.querySelectorAll(managedSelector));
  originals.forEach(node => node.remove());
  const title = document.createElement("title");
  title.textContent = seo.title;
  const nodes: HTMLElement[] = [title];
  for (const tag of seo.tags) {
    const node = document.createElement(tag.tag);
    for (const [name, value] of Object.entries(tag.attributes)) node.setAttribute(name, value);
    if (tag.text) node.textContent = tag.text;
    nodes.push(node);
  }
  nodes.forEach(node => { node.setAttribute("data-blog-seo", ""); document.head.append(node); });
  return () => { nodes.forEach(node => node.remove()); document.head.append(...originals); };
}
